/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type EventFormInstance,
    EventFormInstanceFromJSON,
    EventFormInstanceToJSON,
} from '../models/EventFormInstance';
import {
    type EventFormInstanceRequest,
    EventFormInstanceRequestFromJSON,
    EventFormInstanceRequestToJSON,
} from '../models/EventFormInstanceRequest';

export interface EventFormsCreateRequest {
    eventFormInstanceRequest: EventFormInstanceRequest;
}

export interface EventFormsDestroyRequest {
    id: number;
}

export interface EventFormsListRequest {
    event?: string;
    ordering?: string;
}

/**
 * 
 */
export class EventFormsApi extends runtime.BaseAPI {

    /**
     * Creates request options for eventFormsCreate without sending the request
     */
    async eventFormsCreateRequestOpts(requestParameters: EventFormsCreateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['eventFormInstanceRequest'] == null) {
            throw new runtime.RequiredError(
                'eventFormInstanceRequest',
                'Required parameter "eventFormInstanceRequest" was null or undefined when calling eventFormsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/event-forms/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EventFormInstanceRequestToJSON(requestParameters['eventFormInstanceRequest']),
        };
    }

    /**
     * Viewset to handle forms attached to events.
     */
    async eventFormsCreateRaw(requestParameters: EventFormsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EventFormInstance>> {
        const requestOptions = await this.eventFormsCreateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventFormInstanceFromJSON(jsonValue));
    }

    /**
     * Viewset to handle forms attached to events.
     */
    async eventFormsCreate(requestParameters: EventFormsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EventFormInstance> {
        const response = await this.eventFormsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for eventFormsDestroy without sending the request
     */
    async eventFormsDestroyRequestOpts(requestParameters: EventFormsDestroyRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling eventFormsDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/event-forms/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Validate if this form can be removed.
     */
    async eventFormsDestroyRaw(requestParameters: EventFormsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.eventFormsDestroyRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate if this form can be removed.
     */
    async eventFormsDestroy(requestParameters: EventFormsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.eventFormsDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for eventFormsList without sending the request
     */
    async eventFormsListRequestOpts(requestParameters: EventFormsListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['event'] != null) {
            queryParameters['event'] = requestParameters['event'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/event-forms/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Viewset to handle forms attached to events.
     */
    async eventFormsListRaw(requestParameters: EventFormsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<EventFormInstance>>> {
        const requestOptions = await this.eventFormsListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EventFormInstanceFromJSON));
    }

    /**
     * Viewset to handle forms attached to events.
     */
    async eventFormsList(requestParameters: EventFormsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<EventFormInstance>> {
        const response = await this.eventFormsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
